<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/sk/p20-1.jpg"
              width="100%"
              alt="Blueshark R1 ADAS"
            />
          </div>
          <div class="text t20">
            이중 카메라 시스템은 운행을 모니터하고 녹화합니다.<br />
            (전방 카메라는 선택 사양입니다.)
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/sk/p20-2.jpg"
              width="100%"
              alt="Blueshark R1 ADAS"
            />
          </div>
          <div class="text t20">
            실시간으로 전방 / 후방 카메라로 녹화를 합니다.
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/sk/p20-3.jpg"
              width="100%"
              alt="Blueshark R1 ADAS"
            />
          </div>
          <div class="text t20">
            초음파센서로 차간 거리및 차량 접근 감지 시스템 적용.
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t20 {
  bottom: 8vw;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper_sk/swiper20.vue